"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_blog__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "baa6fe1c-c81b-4044-aa2e-c2afe1471c8b",
    x1: 93.37,
    y1: 98.62,
    x2: 152.67,
    y2: 157.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "16d1f05a-f791-49ff-b4a0-64d415863a39",
    "data-name": "Blog_ic_hi",
    viewBox: "0 0 192 192"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 40,
    width: 128,
    height: 128,
    rx: 16,
    ry: 16,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,166H40a16,16,0,0,1-16-16v2a16,16,0,0,0,16,16h96a16,16,0,0,0,16-16v-2A16,16,0,0,1,136,166Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,64.5h0l-70.5,70L47,145l23,23h66a16,16,0,0,0,16-16Z",
    opacity: 0.2,
    fill: "url(#baa6fe1c-c81b-4044-aa2e-c2afe1471c8b)"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "81.93 134.46 74.14 137.07 73.24 137.37 66.03 139.78 61.07 141.44 54.9 143.51 52.8 141.41 50.7 139.31 48.6 137.21 50.67 131.04 52.33 126.09 54.74 118.87 55.05 117.97 57.65 110.18 64.94 102.9 89.22 127.19 81.93 134.46",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171,21.11a17.17,17.17,0,0,0-24.28,0l-8.16,8.16,24.28,24.28L171,45.38A17.17,17.17,0,0,0,171,21.11Z",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "135.74 32.1 160.01 56.37 162.84 53.55 138.57 29.27 135.74 32.1",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "135.74 32.1 160.01 56.37 162.84 53.55 138.57 29.27 135.74 32.1",
    fill: "#fff",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "81.93 134.46 74.14 137.07 73.24 137.37 66.03 139.78 61.07 141.44 54.9 143.51 52.8 141.41 50.7 139.31 48.6 137.21 50.67 131.04 52.33 126.09 54.74 118.87 55.05 117.97 57.65 110.18 64.94 102.9 89.22 127.19 81.93 134.46",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.87,133.42l-3.14,9.37a2,2,0,0,0,2.58,2.58l9.4-3.15Z",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,110.51l-.15-.15A.24.24,0,0,0,58,110.51Z",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.86,134.39l-.35-.35C81.45,134.5,81.65,134.5,81.86,134.39Z",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.82,40.18,73.14,110.86l-7.39,7.39a1.08,1.08,0,0,0,1,.3,5.72,5.72,0,0,1,6.79,6.79,1.08,1.08,0,0,0,.27,1l7.39-7.39,70.68-70.68Z",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.82,40.18,73.14,110.86l-7.39,7.39a1.08,1.08,0,0,0,1,.3,5.72,5.72,0,0,1,6.79,6.79,1.08,1.08,0,0,0,.27,1l7.39-7.39,70.68-70.68Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.74,32.1,57.65,110.18l.18.18.15.15a.77.77,0,0,0,.37,0,5.72,5.72,0,0,1,7.12,6.71,1.08,1.08,0,0,0,.27,1l7.39-7.39,70.68-70.68Z",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.89,48.25,81.21,118.93l-7.39,7.39a1.08,1.08,0,0,0,1,.31,5.72,5.72,0,0,1,6.71,7.12,1.94,1.94,0,0,0,0,.28l.35.35.07.07L160,56.37Z",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.89,48.25,81.21,118.93l-7.39,7.39a1.08,1.08,0,0,0,1,.31,5.72,5.72,0,0,1,6.71,7.12,1.94,1.94,0,0,0,0,.28l.35.35.07.07L160,56.37Z",
    opacity: 0.12
  }))), /*#__PURE__*/React.createElement("title", null, "blog-hi-dark"), /*#__PURE__*/React.createElement("g", {
    id: "2310b9dd-9ebf-41c0-8548-964c880cb556",
    "data-name": "blog_ic"
  }, /*#__PURE__*/React.createElement("use", {
    id: "23cceab0-150e-46d6-9b7d-9665ca6eb9a5",
    "data-name": "Blog_ic_hi",
    width: 192,
    height: 192,
    xlinkHref: "#16d1f05a-f791-49ff-b4a0-64d415863a39"
  })));
}

var _default = ic_blog__dark;
exports.default = _default;